import { AddTagState } from "@redotech/redo-return-ui/flows/rules/add-tag";
import { RuleTypeDetailsProps } from "@redotech/redo-return-ui/flows/rules/multiple-actions";
import { memo } from "react";
import { RuleTagPicker } from "./rule-tag-picker";

export const AddTagDetails = memo(function AddTagDetails({
  state,
  setState,
  disabled,
}: RuleTypeDetailsProps<AddTagState>) {
  return (
    <RuleTagPicker
      disabled={disabled}
      onChange={setState}
      selectedTagNames={state}
    />
  );
});
